import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "checkbox-wr" }
const _hoisted_2 = ["value", "checked", "disabled"]
const _hoisted_3 = {
  key: 0,
  class: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createElementVNode("input", {
        type: "checkbox",
        value: $props.value,
        onInput: $setup.check,
        checked: $setup.isChecked,
        disabled: $props.disabled
      }, null, 40, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "box" }, null, -1)),
      ($props.label)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.label), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}